module.exports = __webpack_public_path__ + "53bf64360be908c3f3020a474045a560.svg";